"use strict";
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
Object.defineProperty(exports, "__esModule", { value: true });
const i0 = require("@angular/core");
const i1 = require("./mapViewer.component");
const i2 = require("@angular/router");
const i3 = require("@angular/material/snack-bar");
const i4 = require("@angular/material/dialog");
const i5 = require("../xs/services/events/application-events.service");
const i6 = require("../service/map-viewer.service");
var styles_MapViewerComponent = [];
var RenderType_MapViewerComponent = i0.ɵcrt({ encapsulation: 2, styles: styles_MapViewerComponent, data: {} });
exports.RenderType_MapViewerComponent = RenderType_MapViewerComponent;
function View_MapViewerComponent_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 2, "div", [["class", "map-viewer"]], null, null, null, null, null)), (_l()(), i0.ɵeld(1, 0, null, null, 0, "div", [["hidden", ""], ["id", "slider1"]], null, null, null, null, null)), (_l()(), i0.ɵeld(2, 0, null, null, 0, "div", [["class", "cesium-map"], ["style", "width:100%;height:100%;"]], null, null, null, null, null))], null, null); }
exports.View_MapViewerComponent_0 = View_MapViewerComponent_0;
function View_MapViewerComponent_Host_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "map-viewer", [], null, null, null, View_MapViewerComponent_0, RenderType_MapViewerComponent)), i0.ɵdid(1, 770048, null, 0, i1.MapViewerComponent, [i2.Router, i3.MatSnackBar, i4.MatDialog, i5.XsApplicationEventsService, i0.ElementRef, i6.CesiumMapService], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
exports.View_MapViewerComponent_Host_0 = View_MapViewerComponent_Host_0;
var MapViewerComponentNgFactory = i0.ɵccf("map-viewer", i1.MapViewerComponent, View_MapViewerComponent_Host_0, { name: "name" }, {}, []);
exports.MapViewerComponentNgFactory = MapViewerComponentNgFactory;
